


















import { Component, Vue,Prop ,Watch} from "vue-property-decorator";
import _com from "@/assets/js/common";
import cookie from "@/assets/js/cookie"
@Component({
    computed:{
        
    }
})
export default class positionLostModal extends Vue {
    browser = _com.browser();
    mapHref:any= "https://apis.map.qq.com/tools/locpicker?search=1&type=0&key=OTHBZ-3VGKV-UU4P3-ULQNZ-7DPSS-KOFT4&referer=myapp"
		toSelectAddress() {
			this.mapHref = this.mapHref + `&backurl=${encodeURIComponent(location.href)}`;
			location.href = this.mapHref;
		}    
    mounted() {
        
    }

}

